// src/components/Dispatchdetails/EditOrderFrom.jsx
import React, { useState, useEffect, useMemo } from "react";
import { GeoPoint, collection, doc, updateDoc } from "firebase/firestore";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Typography,
  Grid2,
  Button,
  Divider,
  Select,
  TextField,
  CardContent,
  Card,
  Tab,
  Tabs,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { db, storage } from "../../firebase";
import { registrarCambioEnOrden } from "../../redux/accionsRegister";
import { useLoadScript } from "@react-google-maps/api";
import { format } from "date-fns";
import AddNewAddressForm from "./FormsEdithOrders/AddNewAddressForm";
import AdjustGeoReferenceForm from "./FormsEdithOrders/AdjustGeoReferenceForm";
import CreateEmailAuthorizationForm from "./FormsEdithOrders/CreateEmailAuthorizationForm";
import CreateEmailClientForm from "./FormsEdithOrders/CreateEmailClientForm";
import CreateEmailSecondAttemptForm from "./FormsEdithOrders/CreateEmailSecondAttemptForm";
import CreateEmailThirdAttemptForm from "./FormsEdithOrders/CreateEmailThirdAttemptForm";
import CreateEmailConfirmationForm from "./FormsEdithOrders/CreateEmailConfirmationForm";
import RUTReceptorForm from "./RUTReceptorForm";
import NombreReceptorForm from "./NombreReceptorForm";
import UploadFotoEntrega from "./UploadFotoEntrega";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Snackbar, Alert } from "@mui/material";

const libraries = ["geometry", "places"];

const translateStateBicciFalabella = {
  1: "SIN MORADORES",
  99: "Entregado",
  1058: "Creado",
  1059: "Sin Asignar",
  1060: "En Ruta",
  1061: "En Ruta",
  1002: "DOMICILIO NO CORRESPONDE",
  1005: "PROD NO ES LO COMPRADO",
  1006: "PROD INCOMPLETO",
  1007: "PROD FALTANTE",
  1008: "PROD DANIADO",
  1009: "FUERA DE HORARIO",
  1017: "NO RETIRA NO CUMPL FORMAT",
  1019: "FUERA DE COBERTURA",
  1022: "CLIENTE REALIZARA N/C",
  1023: "PRODUCTO ROBADO",
  1027: "NO RETIRADO",
  1029: "DEVOLUCION",
  1031: "PROD N ENTREGADO X TIEMPO",
  1030: "INCIDENCIA EN LA CALLE",
  1032: "FALTA DE INFORMACIÓN",
  1034: "PROD YA FUE RECIBIDO",
  1036: "DIFICULTAD ACCESO DESTINO",
  1038: "CLIENTE CAMBIA DIRCCION",
  1041: "CLIENTE RECHAZA ENVIO",
  1018: "NO CONOCEN AL CLIENTE",
};

const stateTransitions = {
  0: "Creado",
  1: "Creado",
  2: "Confirmado",
  3: "Asignado",
  4: "Por recolectar",
  6: "En ruta destino",
  7: "Visitado",
  8: "Entregado", // meta
  "-1": "Cancelado",
};

const formatTs = (ts) => {
  try {
    if (!ts) return "";
    if (typeof ts?.toMillis === "function")
      return format(ts.toMillis(), "dd/MM/yy HH:mm:ss");
    if (typeof ts?.seconds === "number")
      return format(ts.seconds * 1000, "dd/MM/yy HH:mm:ss");
    if (typeof ts === "number") return format(ts, "dd/MM/yy HH:mm:ss");
    return "";
  } catch {
    return "";
  }
};

const EditOrderFrom = ({
  orderDetails,
  orderDetailsCliente,
  dataOrdesBicciExpress,
  usuarioStorage,
  bloqueaGoogle,
  setOrderDetails,
  orderid,
}) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_APIGOOGLEMAPS_MATRIX,
    libraries,
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storePayload = useSelector((store) => store.accionsRegisterLogs);

  // Tabs
  const [activeTab, setActiveTab] = useState(0);
  const handleChange = (_e, newValue) => setActiveTab(newValue);

  const [orderID, setOrderId] = useState(orderid);

  // Entrega
  const [foto, setFoto] = useState([]);
  const [tokensPics, setTokensPics] = useState([]);
  const [estatus, setEstatus] = useState(orderDetails?.status ?? 0);
  const [date, setDate] = useState("");
  const [comment, setComment] = useState("");
  const [confirmDireccion, setConfirmDirection] = useState("");
  const [newLocation, setNewLocation] = useState(null);

  // Diálogos
  const [finalizeOpen, setFinalizeOpen] = useState(false);
  const [missingOpen, setMissingOpen] = useState(false);
  const [missingList, setMissingList] = useState([]);
  const [cancelOpen, setCancelOpen] = useState(false);

  // dentro de tu componente:
  const [copyOpen, setCopyOpen] = React.useState(false);
  const [copyMsg, setCopyMsg] = React.useState("");

  // Firestore
  const collectionRef = collection(
    db,
    `${process.env.REACT_APP_COL_USERS_ORDERS}`
  );

  useEffect(() => setOrderId(orderid), [orderid]);

  useEffect(() => {
    // Fotos
    const pics = Array.isArray(orderDetails?.pics)
      ? [...orderDetails.pics]
      : [];
    setFoto(pics);

    // Fecha
    const updated =
      orderDetailsCliente?.updatedAt || orderDetails?.updatedAt || null;
    setDate(formatTs(updated));

    // Estatus
    if (typeof orderDetails?.status !== "undefined") {
      setEstatus(orderDetails.status);
    }
  }, [orderDetails, orderDetailsCliente]);

  const hasPhotos = useMemo(
    () =>
      Boolean(orderDetails?.picsTaken) ||
      (Array.isArray(foto) && foto.length > 0),
    [orderDetails?.picsTaken, foto]
  );
  const receiverName =
    orderDetails?.userNameReceptor ||
    orderDetails?.deliveryReceptor ||
    orderDetails?.clientNames ||
    "";
  const receiverRut =
    orderDetails?.userDniReceptor || orderDetails?.deliveryRut || "";

  // ===== Helpers Firestore
  const pushAudit = (payload) => dispatch(registrarCambioEnOrden(payload));

  const updateStatus = async (newStatus) => {
    if (!orderID) return;
    if (newStatus === orderDetails?.status) return;
    const ref = doc(collectionRef, orderID);

    try {
      pushAudit({
        date: new Date(),
        lastValue: orderDetails?.status ?? null,
        newValue: newStatus,
        orderId: orderID,
        type: "infoAdd",
        userId: usuarioStorage.uid,
        var: "status",
      });
      await updateDoc(ref, { status: newStatus });
      setOrderDetails((prev) => ({ ...(prev || {}), status: newStatus }));
      setEstatus(newStatus);
    } catch (e) {
      console.error("Error actualizando estado:", e);
    }
  };

  const handleCopyDeliveryLine = async () => {
    const isDelivered = Number(orderDetails?.status) === 8;

    const fechaEntrega = date || "No disponible"; // usa tu variable `date`
    const nombre =
      orderDetails?.userNameReceptor ||
      orderDetails?.deliveryReceptor ||
      "No disponible";

    const rut =
      orderDetails?.userDniReceptor ||
      orderDetails?.deliveryRut ||
      "No disponible";

    const line = `${isDelivered ? "Entregado" : "No entregado"} ${
      orderDetails.id
    }  | Última actualización: ${fechaEntrega} | Fecha de entrega: ${fechaEntrega} | Nombre: ${nombre} | RUT: ${rut}`;

    try {
      await navigator.clipboard.writeText(line);
      setCopyMsg("Copiado ✅");
      setCopyOpen(true);
    } catch (e) {
      // Fallback por si el navegador bloquea clipboard
      const ta = document.createElement("textarea");
      ta.value = line;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);

      setCopyMsg("Copiado ✅");
      setCopyOpen(true);
    }
  };

  const handleDeleteImage = async (index) => {
    if (!orderID) return;
    const updated = foto.filter((_, i) => i !== index);
    const ref = doc(collectionRef, orderID);
    try {
      await updateDoc(ref, {
        pics: updated,
        picsTaken: updated.length > 0,
      });
      setFoto(updated);
      setOrderDetails((prev) => ({
        ...(prev || {}),
        pics: updated,
        picsTaken: updated.length > 0,
      }));
    } catch (e) {
      console.error("Error al actualizar fotos:", e);
    }
  };

  const addNewGeoPoint = async (loc) => {
    if (!loc || !orderDetails?.id) return;
    const newGeo = new GeoPoint(parseFloat(loc.lat), parseFloat(loc.lng));
    const ref = doc(collectionRef, `${orderDetails.id}`);

    pushAudit({
      date: new Date(),
      lastValue: orderDetails.toAddressLocation,
      newValue: newGeo,
      orderId: orderDetails.id,
      type: "infoAdd",
      userId: usuarioStorage.uid,
      var: "toAddressLocation",
    });

    try {
      await updateDoc(ref, { toAddressLocation: newGeo });
      setOrderDetails((prev) => ({
        ...(prev || {}),
        toAddressLocation: newGeo,
      }));
    } catch (e) {
      console.error("Error actualizando GeoPoint:", e);
    }
    setNewLocation(null);
  };

  // ===== Emails / soporte
  const createEmailclient = (e) => {
    e.preventDefault();
    const uniqueId = e.target.elements.uniqueId.value;
    const data = {
      date: new Date(),
      lastValue: "0",
      newValue: "send",
      orderId: orderDetails.id,
      type: uniqueId,
      userId: usuarioStorage.uid,
      var: "email",
    };
    pushAudit(data);

    const propsData = {
      acction: uniqueId,
      dirección: confirmDireccion,
      data: orderDetails,
      data2: orderDetailsCliente,
      data3: dataOrdesBicciExpress || [],
    };
    navigate(`/dashboard/dispatch/details/${orderDetails.id}/prewiew_email`, {
      state: propsData,
    });
  };

  // ===== Finalizar / Cancelar con validaciones
  const computeMissing = () => {
    const missing = [];
    if (!hasPhotos) missing.push("Fotos de entrega");
    if (!receiverName || receiverName === "isRequire")
      missing.push("Nombre del receptor");
    if (!receiverRut || receiverRut === "isRequire")
      missing.push("RUT del receptor");
    return missing;
  };

  const requestFinalize = () => {
    const missing = computeMissing();
    if (missing.length > 0) {
      setMissingList(missing);
      setMissingOpen(true);
      return;
    }
    setFinalizeOpen(true);
  };

  const confirmFinalize = async () => {
    setFinalizeOpen(false);
    await updateStatus(8);
  };

  const requestCancel = () => setCancelOpen(true);
  const confirmCancel = async () => {
    setCancelOpen(false);
    await updateStatus(-1);
  };

  if (loadError) return "Error";
  if (!isLoaded) return "Loading...";

  // ======== Secciones (contenido) ========
  const sectionDatosOrden = (
    <Box
      sx={{ p: 3, bgcolor: "background.paper", borderRadius: 2, boxShadow: 3 }}
    >
      {/* Origen */}
      <Typography variant="h6" color="primary" gutterBottom>
        Datos Origen
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box>
        <Grid2 container spacing={2}>
          <Grid2 item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">
              Nombre de Usuario:
            </Typography>
            <Typography variant="body2">
              {orderDetails?.placeName || "N/A"}
            </Typography>
          </Grid2>
          <Grid2 item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">
              Dirección:
            </Typography>
            <Typography variant="body2">
              {orderDetails?.fromAddress || "N/A"}
            </Typography>
          </Grid2>
        </Grid2>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Destino */}
      <Typography variant="h6" color="primary" gutterBottom>
        Datos Destino
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid2 container spacing={2}>
        <Grid2 item xs={12} md={6}>
          <Typography variant="subtitle1" fontWeight="bold">
            Nombre:
          </Typography>
          <Typography variant="body2">
            {orderDetails?.userName && orderDetails.userName !== "isRequire"
              ? orderDetails.userName
              : orderDetails?.clientNames || "No disponible"}
          </Typography>
        </Grid2>
        <Grid2 item xs={12} md={6}>
          <Typography variant="subtitle1" fontWeight="bold">
            Destino:
          </Typography>
          <Typography variant="body2">
            {orderDetails?.toAddress || "No disponible"}
          </Typography>
        </Grid2>

        <Grid2 item xs={12} md={6}>
          <Typography variant="subtitle1" fontWeight="bold">
            Email Cliente:
          </Typography>
          <Typography variant="body2">
            {orderDetails?.userEmail && orderDetails.userEmail !== "isRequire"
              ? orderDetails.userEmail
              : orderDetailsCliente?.clientEmail || "No disponible"}
          </Typography>
        </Grid2>
        <Grid2 item xs={12} md={6}>
          <Typography variant="subtitle1" fontWeight="bold">
            Teléfono:
          </Typography>
          <Typography variant="body2">
            {orderDetails?.userPhone ? (
              <>
                +569 {orderDetails.userPhone} |{" "}
                <a href={`tel:+569${orderDetails.userPhone}`}>Llamar</a>
              </>
            ) : (
              "No disponible"
            )}
          </Typography>
        </Grid2>

        <Grid2 item xs={12} md={6}>
          <Typography variant="subtitle1" fontWeight="bold">
            Localidad:
          </Typography>
          <Typography variant="body2">
            {String(
              orderDetailsCliente?.commune1 ??
                orderDetails?.commune2 ??
                "No disponible"
            )}
          </Typography>
        </Grid2>

        <Grid2 item xs={12} md={6}>
          <Typography variant="subtitle1" fontWeight="bold">
            Locación destino:
          </Typography>
          <Typography variant="body2">
            {orderDetails?.toAddressLocation ? (
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${
                  orderDetails.toAddressLocation.latitude ||
                  orderDetails.toAddressLocation.lat
                },${
                  orderDetails.toAddressLocation.longitude ||
                  orderDetails.toAddressLocation.lng
                }`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver en mapa
              </a>
            ) : (
              "No disponible"
            )}
          </Typography>
        </Grid2>
      </Grid2>

      <Divider sx={{ my: 2 }} />

      {/* Datos Adicionales */}
      <Grid2 container spacing={2}>
        <Grid2 item xs={12} md={6}>
          <Typography variant="h6" color="primary" gutterBottom>
            Datos Adicionales
          </Typography>
          <Divider sx={{ mb: 1 }} />
          <Typography variant="subtitle2" fontWeight="bold">
            SOC:
          </Typography>
          <Typography variant="body2">
            {orderDetailsCliente?.soc ||
              orderDetails?.orderID ||
              "No disponible"}
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Typography variant="subtitle2" fontWeight="bold">
            F12:
          </Typography>
          <Typography variant="body2">
            {dataOrdesBicciExpress?.[0]?.F12 ??
              dataOrdesBicciExpress?.[0]?.int_f12 ??
              "Sin F12 registrado"}
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Typography variant="subtitle2" fontWeight="bold">
            Tamaño de Paquete:
          </Typography>
          <Typography variant="body2">
            {orderDetailsCliente?.size || "No disponible"}
          </Typography>
        </Grid2>

        <Grid2 item xs={12} md={6}>
          <Typography variant="h6" color="primary" gutterBottom>
            Medidas
          </Typography>
          <Divider sx={{ mb: 1 }} />
          <Typography variant="body2">
            {`Altura: ${
              orderDetailsCliente?.height ?? orderDetails?.productHeight ?? "?"
            } | `}
            {`Peso: ${
              orderDetailsCliente?.weight ?? orderDetails?.productLength ?? "?"
            } | `}
            {`Ancho: ${
              orderDetailsCliente?.width ?? orderDetails?.productWidth ?? "?"
            }`}
          </Typography>
        </Grid2>
      </Grid2>

      <Divider sx={{ my: 2 }} />

      {/* Cambio de estado */}
      <FormControl fullWidth sx={{ mt: 1 }}>
        <InputLabel id="status-select-label">Estado</InputLabel>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Select
            labelId="status-select-label"
            value={Number(estatus)}
            label="Estado"
            onChange={(e) => setEstatus(Number(e.target.value))}
            sx={{ flexGrow: 1 }}
          >
            {Object.entries(stateTransitions).map(([key, label]) => (
              <MenuItem key={key} value={Number(key)}>
                {label}
              </MenuItem>
            ))}
          </Select>

          <Button
            sx={{
              backgroundColor: "#591E8F",
              color: "#fff",
              whiteSpace: "nowrap",
              "&:hover": { backgroundColor: "#25b2f4", color: "#591e8f" },
            }}
            variant="contained"
            onClick={() => updateStatus(Number(estatus))}
          >
            Guardar Estado
          </Button>
        </Box>
      </FormControl>

      {/* Datos de Entrega (verificación) */}
      <Typography variant="h5" fontWeight="bold" color="primary" sx={{ mt: 3 }}>
        Datos de Entrega
      </Typography>
      <Button
        size="small"
        variant="outlined"
        startIcon={<ContentCopyIcon />}
        onClick={handleCopyDeliveryLine}
        sx={{ mb: 2 }}
      >
        Copiar datos
      </Button>

      <Snackbar
        open={copyOpen}
        autoHideDuration={2000}
        onClose={() => setCopyOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity="success"
          variant="filled"
          onClose={() => setCopyOpen(false)}
        >
          {copyMsg}
        </Alert>
      </Snackbar>
      <Divider sx={{ my: 1 }} />
      <Grid2 container spacing={2}>
        <Grid2 item xs={12} md={6}>
          <Typography variant="subtitle2" fontWeight="bold">
            Foto tomada:
          </Typography>
          <Typography variant="body2">{hasPhotos ? "Sí" : "No"}</Typography>
        </Grid2>
        <Grid2 item xs={12} md={6}>
          <Typography variant="subtitle2" fontWeight="bold">
            Nombre Receptor:
          </Typography>
          <Typography variant="body2">
            {receiverName || "No disponible"}
          </Typography>
        </Grid2>
        <Grid2 item xs={12} md={6}>
          <Typography variant="subtitle2" fontWeight="bold">
            RUT:
          </Typography>
          <Typography variant="body2">
            {receiverRut || "No disponible"}
          </Typography>
        </Grid2>
        <Grid2 item xs={12} md={6}>
          <Typography variant="subtitle2" fontWeight="bold">
            Última actualización:
          </Typography>
          <Typography variant="body2">{date || "No disponible"}</Typography>
        </Grid2>
      </Grid2>

      <Divider sx={{ my: 2 }} />

      {/* Forms receptor */}
      <Grid2 container spacing={2}>
        <Grid2 item xs={12} md={6}>
          <NombreReceptorForm
            orderDetails={orderDetails}
            orderID={orderID}
            usuarioStorage={usuarioStorage}
            setOrderDetails={setOrderDetails}
          />
        </Grid2>
        <Grid2 item xs={12} md={6}>
          <RUTReceptorForm
            orderDetails={orderDetails}
            orderID={orderID}
            usuarioStorage={usuarioStorage}
            setOrderDetails={setOrderDetails}
          />
        </Grid2>
      </Grid2>

      {/* Fotos */}
      <UploadFotoEntrega
        foto={foto}
        setFoto={setFoto}
        setTokensPics={setTokensPics}
        storage={storage}
        orderID={orderID}
        collectionRef={collectionRef}
        dispatch={dispatch}
        registrarCambioEnOrden={registrarCambioEnOrden}
        usuarioStorage={usuarioStorage}
        handleDeleteImage={handleDeleteImage}
      />

      {/* Botones finales */}
      <Box
        sx={{
          textAlign: "center",
          mt: 3,
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Button
          sx={{
            backgroundColor: "green",
            color: "#fff",
            "&:hover": { opacity: 0.9 },
            flex: "1 1 220px",
          }}
          variant="contained"
          disabled={Number(orderDetails?.status) === 8}
          onClick={requestFinalize}
        >
          {Number(orderDetails?.status) !== 8
            ? "Finalizar Orden"
            : "Finalizado (Entregado)"}
        </Button>
        <Button
          sx={{
            backgroundColor: "red",
            color: "#fff",
            "&:hover": { opacity: 0.9 },
            flex: "1 1 220px",
          }}
          variant="contained"
          disabled={Number(orderDetails?.status) === -1}
          onClick={requestCancel}
        >
          {Number(orderDetails?.status) !== -1 ? "Cancelar Orden" : "Cancelado"}
        </Button>
      </Box>
    </Box>
  );

  const sectionContenido = (
    <Box sx={{ p: 2 }}>
      <Typography variant="body1" fontWeight={700}>
        Estatus:
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {orderDetailsCliente &&
          translateStateBicciFalabella[orderDetailsCliente.falabella_status]}
      </Typography>

      <Typography variant="body1" fontWeight={700}>
        Courier:
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        BICCI
      </Typography>

      <Typography variant="body1" fontWeight={700}>
        Contenido:
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {Array.isArray(dataOrdesBicciExpress) &&
        dataOrdesBicciExpress.length > 0 ? (
          <ul>
            {dataOrdesBicciExpress.map((item, i) => (
              <li key={i}>
                {item.PRODUCTO || item.productName || "Producto"} | SKU{" "}
                {item.SKU || item.productSku || "?"}
              </li>
            ))}
          </ul>
        ) : (
          "No data"
        )}
      </Typography>

      {Array.isArray(dataOrdesBicciExpress) &&
      dataOrdesBicciExpress.length > 0 ? (
        <>
          <Typography variant="body1" fontWeight={700}>
            Código Producto:
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {dataOrdesBicciExpress[0].SKU ||
              dataOrdesBicciExpress[0].productSku ||
              "?"}
          </Typography>

          <Typography variant="body1" fontWeight={700}>
            Descripción:
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {dataOrdesBicciExpress[0].PRODUCTO ||
              dataOrdesBicciExpress[0].productName ||
              "?"}
          </Typography>

          <Typography variant="body1" fontWeight={700}>
            Valor:
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {dataOrdesBicciExpress[0].VALOR ||
              dataOrdesBicciExpress[0].productValue ||
              "?"}
          </Typography>
        </>
      ) : (
        <Typography variant="body2">No data...</Typography>
      )}

      <Typography variant="body1" fontWeight={700}>
        Cantidad:
      </Typography>
      <Typography variant="body2">
        {orderDetailsCliente?.quantity_packages ?? "?"}
      </Typography>
    </Box>
  );

  const sectionDriver = (
    <Box sx={{ p: 2 }}>
      <Typography variant="body1" fontWeight={700}>
        ID:
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {orderDetails?.driverID || "N/A"}
      </Typography>

      <Typography variant="body1" fontWeight={700}>
        Foto:
      </Typography>
      <Box sx={{ mb: 2 }}>
        {orderDetails?.driverAvatar ? (
          <img
            id="imgavatar"
            src={orderDetails.driverAvatar}
            alt="driver"
            style={{ maxWidth: 120 }}
          />
        ) : (
          "N/A"
        )}
      </Box>

      <Typography variant="body1" fontWeight={700}>
        Nombre:
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {orderDetails?.driverName || "N/A"}
      </Typography>

      <Typography variant="body1" fontWeight={700}>
        Teléfono:
      </Typography>
      <Typography variant="body2">
        {orderDetails?.driverPhone || "N/A"}
      </Typography>
    </Box>
  );

  const sectionAcciones = (
    <Box sx={{ p: 2, textAlign: "left" }}>
      <Typography component="div">
        Generar maqueta email de primer intento fallido
      </Typography>
      <CreateEmailClientForm createEmailclient={createEmailclient} />
      <Divider sx={{ my: 2 }} />

      <Typography component="div">
        Generar maqueta email de segundo intento fallido
      </Typography>
      <CreateEmailSecondAttemptForm createEmailclient={createEmailclient} />
      <Divider sx={{ my: 2 }} />

      <Typography component="div">
        Generar maqueta email de tercer intento fallido
      </Typography>
      <CreateEmailThirdAttemptForm createEmailclient={createEmailclient} />
      <Divider sx={{ my: 2 }} />

      <Typography component="div">Confirmación de dirección</Typography>
      <CreateEmailConfirmationForm createEmailclient={createEmailclient} />
      <Divider sx={{ my: 2 }} />

      <Typography component="div">
        Autorización de cambio de domicilio
      </Typography>
      <CreateEmailAuthorizationForm createEmailclient={createEmailclient} />
      <Divider sx={{ my: 2 }} />

      {!orderDetails?.int_falabella_status && (
        <>
          <Typography component="div">Editar dirección con error.</Typography>
          <Typography component="div">
            Dirección actual: {orderDetails?.toAddress || "N/A"}
          </Typography>
          <AddNewAddressForm
            setOrderDetails={setOrderDetails}
            orderDetails={orderDetails}
            usuarioStorage={usuarioStorage}
            registrarCambioEnOrden={registrarCambioEnOrden}
            dispatch={dispatch}
            collectionRef={collectionRef}
          />
          <Divider sx={{ my: 2 }} />
        </>
      )}

      {bloqueaGoogle !== true && (
        <>
          <AdjustGeoReferenceForm
            orderDetails={orderDetails}
            addNewGeoPoint={addNewGeoPoint}
          />
          <Divider sx={{ my: 2 }} />
        </>
      )}
    </Box>
  );

  const sectionLog = (
    <Box sx={{ p: 2, textAlign: "left" }}>
      {storePayload?.upload ? (
        storePayload.logs.map((item, i) => (
          <Card key={i} sx={{ m: 0.5, p: 1 }} variant="outlined">
            <div>{formatTs(item?.date)}</div>
            <div>Usuario</div>
            <div>{item?.userId}</div>
            <div>Acción: {item?.var}</div>
            <div>
              {typeof item?.lastValue === "object" &&
              item?.lastValue !== null ? (
                <>Geopunto</>
              ) : (
                <>
                  <div>valor anterior: {String(item?.lastValue)}</div>
                  <div>nuevo valor: {String(item?.newValue)}</div>
                </>
              )}
            </div>
          </Card>
        ))
      ) : (
        <>Sin cambios</>
      )}
    </Box>
  );

  const panes = [
    { label: "Datos de Orden", content: sectionDatosOrden },
    { label: "Contenido de Orden", content: sectionContenido },
    { label: "Datos de Driver", content: sectionDriver },
    { label: "Acciones", content: sectionAcciones },
    { label: "Registro de Acciones", content: sectionLog },
  ];

  if (!orderID) return <LinearProgress />;

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        variant="fullWidth"
        textColor="primary"
        indicatorColor="primary"
      >
        {panes.map((p, i) => (
          <Tab key={i} label={p.label} />
        ))}
      </Tabs>

      {panes.map((p, i) => (
        <TabPanel key={i} value={activeTab} index={i}>
          <Box>{p.content}</Box>
        </TabPanel>
      ))}

      {/* Diálogo: faltan datos */}
      <Dialog
        open={missingOpen}
        onClose={() => setMissingOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Faltan datos para finalizar</DialogTitle>
        <DialogContent dividers>
          <Typography sx={{ mb: 1 }}>
            Para finalizar la orden debes completar los siguientes campos:
          </Typography>
          <List dense>
            {missingList.map((m, i) => (
              <ListItem key={i}>
                <ListItemIcon>
                  <ErrorOutlineIcon color="error" />
                </ListItemIcon>
                <ListItemText primary={m} />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setMissingOpen(false)}>Volver</Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo: confirmar finalizar */}
      <Dialog
        open={finalizeOpen}
        onClose={() => setFinalizeOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Confirmar finalización</DialogTitle>
        <DialogContent dividers>
          <Typography sx={{ mb: 1 }}>
            ¿Confirmas que deseas marcar la orden como <b>Entregada</b>?
          </Typography>
          <List dense>
            <ListItem>
              <ListItemIcon>
                <CheckCircleOutlineIcon
                  color={hasPhotos ? "success" : "disabled"}
                />
              </ListItemIcon>
              <ListItemText
                primary={`Fotos de entrega: ${hasPhotos ? "Sí" : "No"}`}
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleOutlineIcon
                  color={receiverName ? "success" : "disabled"}
                />
              </ListItemIcon>
              <ListItemText
                primary={`Nombre receptor: ${receiverName || "No disponible"}`}
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleOutlineIcon
                  color={receiverRut ? "success" : "disabled"}
                />
              </ListItemIcon>
              <ListItemText
                primary={`RUT receptor: ${receiverRut || "No disponible"}`}
              />
            </ListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFinalizeOpen(false)}>Cancelar</Button>
          <Button variant="contained" onClick={confirmFinalize} color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo: confirmar cancelación */}
      <Dialog
        open={cancelOpen}
        onClose={() => setCancelOpen(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Cancelar orden</DialogTitle>
        <DialogContent dividers>
          <Typography>¿Estás seguro de cancelar esta orden?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCancelOpen(false)}>Volver</Button>
          <Button variant="contained" color="error" onClick={confirmCancel}>
            Cancelar Orden
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

// TabPanel
const TabPanel = ({ children, value, index }) => (
  <Box
    role="tabpanel"
    hidden={value !== index}
    sx={{ p: 0, display: value === index ? "block" : "none" }}
  >
    <Card sx={{ p: 0, boxShadow: 2 }}>
      <CardContent>{children}</CardContent>
    </Card>
  </Box>
);

export default EditOrderFrom;
